/**
 * @generated SignedSource<<f125584d273bb66dd5efbe7bd15fb772>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type GroupContentJudgeStatus = "PENDING" | "APPROVED" | "%future added value";
export type PageKind = "LANDING" | "FORM" | "CONFIRM" | "THANKS" | "%future added value";
export type UserRole = "SUPER" | "ADMIN_ALL" | "ADMIN" | "JUDGE" | "CLIENT" | "SAAS_CLIENT" | "%future added value";
export type FunnelPopupGroupList_Query$variables = {
  siteSlug: string;
  funnelIds?: ReadonlyArray<string> | null;
  pageIds?: ReadonlyArray<string> | null;
  count?: number | null;
  cursor?: string | null;
  sourceId?: string | null;
  device?: Device | null;
  withArchived?: boolean | null;
  status?: DistributionStatus | null;
};
export type FunnelPopupGroupList_QueryVariables = FunnelPopupGroupList_Query$variables;
export type FunnelPopupGroupList_Query$data = {
  readonly viewer: {
    readonly role: UserRole;
  };
  readonly site: {
    readonly popupGroups: {
      readonly __id: string;
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly endDate: string | null;
          readonly id: string;
          readonly memo: string | null;
          readonly name: string;
          readonly isArchive: boolean;
          readonly popups: {
            readonly totalCount: number;
          } | null;
          readonly page: {
            readonly id: string;
            readonly kind: PageKind;
            readonly name: string;
            readonly sortNumber: number;
            readonly url: string;
          };
          readonly slug: string;
          readonly status: DistributionStatus;
          readonly startDate: string | null;
          readonly thumbnailImageUrl: string | null;
          readonly updatedAt: string;
          readonly judgeStatus: GroupContentJudgeStatus | null;
        } | null;
      } | null> | null;
    };
  };
};
export type FunnelPopupGroupList_QueryResponse = FunnelPopupGroupList_Query$data;
export type FunnelPopupGroupList_Query = {
  variables: FunnelPopupGroupList_QueryVariables;
  response: FunnelPopupGroupList_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "device"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "funnelIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteSlug"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withArchived"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "siteSlug"
  }
],
v11 = {
  "kind": "Variable",
  "name": "device",
  "variableName": "device"
},
v12 = {
  "kind": "Variable",
  "name": "funnelIds",
  "variableName": "funnelIds"
},
v13 = {
  "kind": "Variable",
  "name": "pageIds",
  "variableName": "pageIds"
},
v14 = {
  "kind": "Variable",
  "name": "sourceId",
  "variableName": "sourceId"
},
v15 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "status"
},
v16 = {
  "kind": "Variable",
  "name": "withArchived",
  "variableName": "withArchived"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = [
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PopupGroupEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memo",
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "kind",
                "value": "B_PATTERN"
              }
            ],
            "concreteType": "PopupConnection",
            "kind": "LinkedField",
            "name": "popups",
            "plural": false,
            "selections": [
              (v17/*: any*/)
            ],
            "storageKey": "popups(kind:\"B_PATTERN\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sortNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "judgeStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }
],
v21 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v11/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelPopupGroupList_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": "popupGroups",
            "args": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "concreteType": "PopupGroupConnection",
            "kind": "LinkedField",
            "name": "__FunnelPopupGroupList_popupGroups_connection",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "FunnelPopupGroupList_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v21/*: any*/),
            "concreteType": "PopupGroupConnection",
            "kind": "LinkedField",
            "name": "popupGroups",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v21/*: any*/),
            "filters": [
              "funnelIds",
              "pageIds",
              "sourceId",
              "device",
              "withArchived",
              "status"
            ],
            "handle": "connection",
            "key": "FunnelPopupGroupList_popupGroups",
            "kind": "LinkedHandle",
            "name": "popupGroups"
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0d47949a37b1abb8d3746df0ecfa68c",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "count",
          "cursor": "cursor",
          "direction": "forward",
          "path": [
            "site",
            "popupGroups"
          ]
        }
      ]
    },
    "name": "FunnelPopupGroupList_Query",
    "operationKind": "query",
    "text": "query FunnelPopupGroupList_Query(\n  $siteSlug: String!\n  $funnelIds: [ID!]\n  $pageIds: [ID!]\n  $count: Int\n  $cursor: String\n  $sourceId: ID\n  $device: Device\n  $withArchived: Boolean\n  $status: DistributionStatus\n) {\n  viewer {\n    role\n    id\n  }\n  site(slug: $siteSlug) {\n    popupGroups(first: $count, after: $cursor, funnelIds: $funnelIds, pageIds: $pageIds, sourceId: $sourceId, device: $device, withArchived: $withArchived, status: $status) {\n      totalCount\n      edges {\n        node {\n          endDate\n          id\n          memo\n          name\n          isArchive\n          popups(kind: B_PATTERN) {\n            totalCount\n          }\n          page {\n            id\n            kind\n            name\n            sortNumber\n            url\n          }\n          slug\n          status\n          startDate\n          thumbnailImageUrl\n          updatedAt\n          judgeStatus\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d390d9d12feabc467e9d00b75a68224c";

export default node;
